import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';

@Component({
    selector: 'deal-expired-modal',
    templateUrl: './deal-expired-modal.component.html',
    styleUrl: './deal-expired-modal.component.css'
})
export class DealExpiredModalComponent {
    constructor(
        public ref: DynamicDialogRef,
        private router: Router
    ) {}

    goToDashboard() {
        this.router.navigate(['/dashboard']);
        this.ref.close();
    }
}
